<template>
    <div v-if="isVisible"
         :class="['informative-tooltip', `position-${position}`, `alignment-${getXYAlignment}`, { 'fade' : fadeOut }]"
         :style="{ width }">
        <div class="tool-tip">
            <div class="text" v-html="text"></div>
            <div class="buttons">
                <div @click="triggerModalCallback()" :class="buttonType" v-html="buttonText"></div>
            </div>

            <div :class="['arrow', `position-${position}`, `alignment-${getXYAlignment}`]"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InformativeTooltip",
        props: {
            text: String,
            buttonText: String,
            buttonType: {
                type: String,
                default: 'accept'
            },
            width: String,
            position: {
                type: String,
                default: 'bottom'
            },
            alignment: {
                type: String,
                default: 'middle'
            },
            callback: {
                type: Function,
                default: () => {}
            },
        },
        computed: {
            getXYAlignment() {
                const positionIsHorizontalAndInMiddle = ['top', 'bottom'].indexOf(this.position) === -1 && this.alignment === "middle";
                return positionIsHorizontalAndInMiddle ? `${this.alignment}-vertical` : this.alignment;
            }
        },
        data() {
            return {
                isVisible: true,
                fadeOut: false,
            }
        },
        methods: {
            triggerModalCallback() {
                try {
                    this.callback();
                    this.hideInformativeTooltip();
                } catch (e) {
                    console.error(e);
                }
            },

            async hideInformativeTooltip() {
                this.fadeOut = true;
                await this.timeout(500);
                this.isVisible = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    $padding: 8px;
    $arrow-size: 5px;

    @mixin alignment-styling($isArrow: false) {
        $positioning: calc(50% - #{$padding});
        $positioning-vertical: calc(50% - #{$padding + $arrow-size});

        @if $isArrow {
            $positioning: $padding;
            $positioning-vertical: $padding;
        }

        &.alignment {
            &-left {
                left: $positioning;
            }

            &-right {
                right: $positioning;
            }

            &-middle {
                left: 50%;
                transform: translateX(-50%);
            }

            &-middle-vertical {
                top: 50%;
                transform: translateY(-50%);
            }

            &-top {
                top: $positioning-vertical;
            }

            &-bottom {
                bottom: $positioning-vertical;
            }
        }
    }

    .informative-tooltip {
        z-index: 1000;
        position: absolute;

        font-size: 12px;
        line-height: 16px;

        border-radius: 3px;
        background: $black-1;
        color: white;

        opacity: 1;
        transition: opacity .5s;

        @include alignment-styling($isArrow: false);

        $positionCalc: calc(100% + #{$padding});
        &.position {
            &-top {
                bottom: $positionCalc;
            }

            &-bottom {
                top: $positionCalc;
            }

            &-right {
                left: $positionCalc;
            }
        }

        &.fade {
            opacity: 0;
        }

        .tool-tip {
            position: relative;
            padding: $padding;
            cursor: default;

            .text {
                padding: 0 0 12px;
                white-space: pre-wrap;
            }

            .buttons {
                display: flex;
                justify-content: space-between;
            }

            .accept,
            .close {
                cursor: pointer;
                font-weight: bold;
            }

            .accept {
                color: $green;
            }

            .close {
                color: rgba($gray-1, .25);
            }

            $arrow-spacing-diff: -($arrow-size * 2);
            .arrow {
                position: absolute;

                width: 0;
                height: 0;

                @include alignment-styling($isArrow: true);

                &.position {
                    &-top {
                        bottom: $arrow-spacing-diff;

                        border-top: $arrow-size solid $black-1;
                        border-bottom: $arrow-size solid transparent;
                        border-left: $arrow-size solid transparent;
                        border-right: $arrow-size solid transparent;
                    }

                    &-bottom {
                        top: $arrow-spacing-diff;

                        border-bottom: $arrow-size solid $black-1;
                        border-top: $arrow-size solid transparent;
                        border-left: $arrow-size solid transparent;
                        border-right: $arrow-size solid transparent;
                    }

                    &-left {
                        right: $arrow-spacing-diff;

                        border-top: $arrow-size solid transparent;
                        border-bottom: $arrow-size solid transparent;
                        border-left: $arrow-size solid $black-1;
                        border-right: $arrow-size solid transparent;
                    }

                    &-right {
                        left: $arrow-spacing-diff;

                        border-top: $arrow-size solid transparent;
                        border-bottom: $arrow-size solid transparent;
                        border-left: $arrow-size solid transparent;
                        border-right: $arrow-size solid $black-1;
                    }
                }
            }
        }
    }
</style>